// extracted by mini-css-extract-plugin
export default {"title":"j_-z","warning":"k_-z","sizeOptionsLegendText":"l_-z"};